import { AxiosResponse } from 'axios';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import StoreService from '../../utils/StoreService';
import { NOTIFICATION_NUMBER } from '../App/constants';
import { updateNotificationAction } from './actions';

import {
   NOTIFICATIONS_SUCCESS, 
   NOTIFICATION_INIT, 
   NOTIFICATIONS_ERROR,
   ALL_NOTIFICATIONS,
   ALL_NOTIFICATIONS_SUCCESS,
   ALL_NOTIFICATIONS_ERROR,
   UPDATE_NOTIFICATIONS,
   UPDATE_NOTIFICATIONS_ERROR,
   UPDATE_NOTIFICATIONS_SUCCESS,
   ITEMS_PER_PAGE,
   DELETE_NOTIFICATION,
   DELETE_NOTIFICATION_ERROR,
   DELETE_NOTIFICATION_SUCCESS
} from './constants';

import { deleteNotificationService, getAllNotificationsService, updateNotificationsService } from './services';

function* notificationsFlow(action: any) {
    const message =  action.payload.message;
    switch (action.payload.typeOfNotification) {
       case NOTIFICATIONS_SUCCESS:
          yield put({type: NOTIFICATIONS_SUCCESS, message})  
          break;
       case NOTIFICATIONS_ERROR:
          yield put({type: NOTIFICATIONS_ERROR, message})  
          break;
    }  
}

function* allNotificationsFlow(action: any) {
   const {page} = action;
   try {
      const response: AxiosResponse = yield call(getAllNotificationsService, page, ITEMS_PER_PAGE);
      yield put({type: ALL_NOTIFICATIONS_SUCCESS, response});
      StoreService.dispatch(updateNotificationAction());
   } catch (error) {
      yield put({type: ALL_NOTIFICATIONS_ERROR, error})
   }
}

function* updateNotificationsFlow() {
   try {
      const response: AxiosResponse = yield call(updateNotificationsService);
      yield put({type: UPDATE_NOTIFICATIONS_SUCCESS, response});
      yield put({type: NOTIFICATION_NUMBER});
   } catch (error) {
      yield put({type: UPDATE_NOTIFICATIONS_ERROR, error})
   }
}

function* deleteNotification(action: any) {
   const {id} = action;
   try {
      const response: AxiosResponse = yield call(deleteNotificationService, id);
      yield put({type: DELETE_NOTIFICATION_SUCCESS, response})
      yield put({type: ALL_NOTIFICATIONS});
   } catch (error) {
      yield put({type: DELETE_NOTIFICATION_ERROR, error})
   }
}

export default function* notificationsSaga() {
    yield all([
       takeLatest(NOTIFICATION_INIT, notificationsFlow),
       takeLatest(ALL_NOTIFICATIONS, allNotificationsFlow),
       takeLatest(UPDATE_NOTIFICATIONS, updateNotificationsFlow),
       takeLatest(DELETE_NOTIFICATION, deleteNotification)
    ])
}